var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMoneyRecive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.169 6.25c-.19-.27-.39-.52-.6-.77l-.76.77h1.36zM17.75 3.82v1.36l.77-.76c-.25-.21-.5-.41-.77-.6zM22.53 2.531c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-2.95 2.95c.38.33.73.69 1.06 1.06l2.95-2.95zM17.002 2.25c-.4 0-.72.32-.74.71.52.25 1.02.53 1.49.86V3c0-.41-.34-.75-.75-.75zM21.002 6.25h-.83c.33.47.62.97.86 1.49.4-.02.72-.34.72-.74 0-.41-.34-.75-.75-.75zM13.05 14.75c.39 0 .7-.35.7-.78 0-.54-.15-.62-.49-.74l-.51-.18v1.7h.3z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7.75h-4c-.1 0-.19-.02-.29-.06a.782.782 0 0 1-.41-.41.868.868 0 0 1-.05-.28V3c0-.01.01-.02.01-.04C14.96 2.35 13.52 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.52-.35-2.96-.96-4.26-.01 0-.02.01-.04.01zm-5.75 6.23c0 1.25-.99 2.28-2.2 2.28h-.3v.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.25h-.08c-1.33 0-2.42-1.12-2.42-2.5 0-.42.34-.76.75-.76s.75.34.75.75c0 .55.41 1 .92 1h.08v-2.22l-1-.35c-.64-.22-1.5-.69-1.5-2.16 0-1.25.99-2.28 2.2-2.28h.3V7.5c0-.41.34-.75.75-.75s.75.34.75.75v.25h.08c1.33 0 2.42 1.12 2.42 2.5 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.55-.41-1-.92-1h-.08v2.22l1 .35c.64.22 1.5.69 1.5 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.74 10.77.51.18v-1.7h-.3c-.38 0-.7.35-.7.78 0 .54.15.62.49.74z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMoneyRecive);
export default __webpack_public_path__ + "static/media/vuesax-bold-money-recive.e4d2755a5c02add8b86d5e3caa9b011e.svg";
export { ForwardRef as ReactComponent };